import { parse } from "url";
import QS from "querystring";

const query = path => QS.parse(parse(path).query);

export default query;
